import { useEffect, useState } from 'react';

import { type ActivityLogEntry, getUserActivity } from '../services/activity';

export function useActivityFeed(limit = 5) {
  const [activities, setActivities] = useState<ActivityLogEntry[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchActivity = async () => {
      try {
        const data = await getUserActivity(limit);
        setActivities(data);
      } catch {
        setActivities([]);
      } finally {
        setIsLoading(false);
      }
    };
    void fetchActivity();
  }, [limit]);

  return { activities, isLoading };
}
